import type { TopicDatabase } from '../../../../types';
import { useDeleteTopic } from '../../api/useDeleteTopic';

type Props = {
  topic: TopicDatabase;
  onDeleted?: (topicId: string) => void;
};

export function useDeleteTopicModal(props: Props) {
  const deleteTopic = useDeleteTopic();

  // ConfirmDeleteDialog closes on success and surfaces a rejection as a server error.
  async function handleConfirm() {
    await deleteTopic.mutateAsync(props.topic.id);
    props.onDeleted?.(props.topic.id);
  }

  return {
    handleConfirm,
  };
}
